export default {"src":"/_next/static/media/Neuroinfectious Diseases.af7d6f21.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};